import { type ComponentType, lazy } from 'react';
import { createDynamicImportWithRetry } from '@fatso83/retry-dynamic-import';

export type ComponentImport = () => Promise<{ default: ComponentType<any> }>;

const customRetryImport = createDynamicImportWithRetry(10);

export const lazyWithRetry = (componentImport: ComponentImport) =>
  lazy(() => customRetryImport(componentImport));
